export const ALL_ORDER_STATUSES = [
    'Paid',
    'Declined',
    'Shipped',
    'Awaiting Upstream Approval',
    'Awaiting Fulfilment',
    'Completed',
    'Awaiting Approval',
];

export const ALL_SHIPPING_STATUSES = [
    'Awaiting Shipment',
    'Awaiting Pickup',
    'Partially Shipped',
    'Shipped',
];

export const ALL_ORDER_INVOICE_STATUSES = [
    'Unpaid',
    'Paid',
    'Marked As Paid',
];

export const buildPayOrderPayload = (originalPayload) => {
    let payload = {
        InvoiceID: Number(originalPayload.InvoiceID),
        OrderID: Number(originalPayload.OrderID),
        PaymentMethod: '',
        SaveCard:
            typeof originalPayload.SaveCard != 'undefined'
                ? originalPayload.SaveCard == 1
                : false,
        Token: originalPayload.Token || '',
        Gateway: originalPayload.PaymentMethod == 'payfast' ? 'payfast' : 'stripe',
        Card: {
            CardName: originalPayload.CardName || '', // ?
            Number: originalPayload.Number || '',
            ExpiryMonth: originalPayload.ExpiryMonth || '',
            ExpiryYear: originalPayload.ExpiryYear || '',
        },
    };

    // Payment Method
    if (typeof originalPayload.PaymentMethod != 'undefined') {
        if (originalPayload.PaymentMethod == 'banktransfer') {
            payload.PaymentMethod = 'invoice-bank-transfer';
        } else if (originalPayload.PaymentMethod == 'accountbalance') {
            payload.PaymentMethod = 'invoice-account';
        }
            else if (originalPayload.PaymentMethod == 'payfast') {
                payload.PaymentMethod = 'invoice-payfast';
        } else if (originalPayload.PaymentMethod == 'stripe') {
            if (originalPayload.CreditCardID !== undefined && originalPayload.CreditCardID !== 'add-new-card' && originalPayload.CreditCardID > 0) {
                payload.PaymentMethod = 'invoice-card';
                payload.CardID = originalPayload.CreditCardID;
            } else {
                payload.PaymentMethod = 'invoice-token';
            }
        }
    }

    if (payload.PaymentMethod != 'invoice-token') {
        delete payload.Token;
        delete payload.Card;
        delete payload.SaveCard;
    }

    delete payload.OrderID;

    return payload;
};
